export default "/rETH-WETH-BPT.621b94422f2e55be76ab2969a3860b08.png";